import { AdminFinanceWebService } from '@linktivity/gds-neo';
import config from '../config';

const financeApi = new AdminFinanceWebService.FinanceApi(config);

export default financeApi;
